"use client";
import { jsxs as N, jsx as d } from "react/jsx-runtime";
import { createContext as A, useContext as R, useState as T, useCallback as S, createElement as k, useRef as $, useEffect as D } from "react";
import { COMPONENT_SIZES as y } from "../common/constants/componentSizes.js";
import { LAYERS as j } from "../common/constants/layers.js";
import { setTimer as L } from "../common/helpers/timer.js";
import { useModal as w } from "../common/hooks/useModal.js";
import { boxPadding as W } from "../common/styles/mixins/boxPadding.js";
import Y from "../components/portal/Portal.js";
import Z from "../components/toast/Toast.js";
import { css as E } from "@emotion/react";
import I from "@emotion/styled";
import { MOTION_DURATIONS as _ } from "../tokens/motion-durations/MotionDurations.js";
import { SIZES as b } from "../tokens/sizes/Sizes.js";
import { SPACINGS as C } from "../tokens/spacings/Spacings.js";
const e = _.fast, O = A(null), z = () => {
  const o = R(O);
  if (!o)
    throw new Error("A toast provider must wrap toast tag.");
  return o;
}, P = ({
  children: o,
  feErrorTimeout: t = !1,
  feTimeout: n = 3,
  ...c
}) => {
  const [a, i] = T([]), { willRender: f } = w({
    closeDelay: e,
    interruptive: !0,
    open: a.length > 0
  }), l = S(
    (r) => {
      const m = Math.random().toString(16).slice(2), s = {
        ...r,
        id: m,
        open: !0
      };
      return i((u) => [s, ...u]), s.id;
    },
    [i]
  ), p = S(
    (r) => {
      const m = a.find((s) => s.id === r);
      m && (m.open = !1), i(
        (s) => s.filter((u) => u.id !== r)
      );
    },
    [i]
  );
  return /* @__PURE__ */ N(O.Provider, { value: { toasts: a, addToast: l, removeToast: p }, children: [
    o,
    /* @__PURE__ */ d(Y, { feRender: f, "data-portals": "toast", children: /* @__PURE__ */ d(G, { ...c, "data-comp": "toast-wrapper", children: a.map((r) => /* @__PURE__ */ k(
      B,
      {
        ...r,
        errorShouldTimeout: t,
        key: r.id,
        timer: n
      }
    )) }) })
  ] });
};
P.displayName = "ToastProvider";
const it = P, B = ({
  errorShouldTimeout: o,
  feSeverity: t,
  id: n,
  timer: c,
  open: a,
  ...i
}) => {
  var g;
  const f = $(!1), l = $(null), [p, r] = T(((g = l.current) == null ? void 0 : g.offsetHeight) ?? 0), [m, s] = T(a), { isOpen: u } = w({
    closeDelay: e,
    interruptive: !0,
    onClose: () => n && v(n),
    open: m
  }), { removeToast: v } = z(), h = $({
    clear: () => {
    },
    pause: () => {
    },
    resume: () => {
    }
  }), H = () => {
    h.current.pause();
  }, M = () => {
    h.current.resume();
  };
  return D(() => {
    var x;
    f.current || (f.current = !0, r(((x = l.current) == null ? void 0 : x.offsetHeight) ?? 0), t === "error" && !o && (c = null), c && (h.current = L({
      callback: () => {
        s(!1), setTimeout(() => n && v(n), e);
      },
      delay: c * 1e3
    })));
  }, []), /* @__PURE__ */ d(U, { id: n, stHeight: p, stVisible: u, children: /* @__PURE__ */ d(
    Z,
    {
      ...i,
      feCloseButton: {
        onClick: () => {
          s(!1);
        }
      },
      onMouseEnter: H,
      onMouseLeave: M,
      feSeverity: t,
      ref: l
    }
  ) });
}, G = I.div(
  ({ feLayer: o }) => E`
		${W("inline")};

		display: flex;
		flex-direction: column;
		left: 50%;
		position: fixed;
		top: calc(${y.headerHeight} + ${b.s16});
		transform: translateX(-50%);
		width: ${y.toastWidth};
		z-index: ${o ?? j.toast};
	`
), U = I.div(
  ({ stHeight: o, stVisible: t }) => E`
		height: ${t ? `${o}px` : "0"};
		margin-bottom: ${t ? C.md : 0};
		opacity: ${!t && 0};
		overflow: hidden;
		transform: ${!t && "translateY(-" + C.md + ")"};
		transition:
			opacity ${e}ms ${t && `${e}ms`},
			transform ${e}ms ${t && `${e}ms`},
			height ${e}ms ${!t && `${e}ms`},
			margin-bottom ${e}ms ${!t && `${e}ms`};
	`
);
export {
  it as default,
  z as useToast
};
